import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { rem } from '../../utils/utils';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(['content', 'trigger']);

const DefinitionTooltipTheme = defineMultiStyleConfig({
  baseStyle: {
    content: {
      maxWidth: rem(320),
      paddingX: '12',
      paddingY: '8',
    },
    trigger: {
      _hover: {
        borderBottomColor: 'purple.50',
      },
      borderBottom: '1px dotted',
      borderBottomColor: 'neutral.60',
      display: 'inline-block',
      fontWeight: 'inherit',
      width: 'fit-content',
    },
  },
});

export default DefinitionTooltipTheme;
